import launchDarklyService from "../../services/launchdarkly";
import { setPerAccessFilterPersistenceEnabled } from "@components/helper/localStorageHelper";
import {
  LD_FLAG_IDEA_MDP_457,
  LD_FLAG_IDEA_MDP_514,
  LD_FLAG_IDEA_MDP_526,
  LD_FLAG_IDEA_MDP_557,
  LD_FLAG_IDEA_MDP_558,
  LD_FLAG_IDEA_MDP_556,
  LD_FLAG_IDEA_MDP_570,
  LD_FLAG_IDEA_MDP_577,
  LD_FLAG_IDEA_MDP_579,
  LD_FLAG_IDEA_MDP_586,
  LD_FLAG_IDEA_MDP_582,
  LD_FLAG_IDEA_MDP_592,
  LD_FLAG_IDEA_MDP_608_ORG_OBJECT_NAME_VALIDATION,
  LD_FLAG_IDEA_MDP_609,
  LD_FLAG_IDEA_MDP_552,
  LD_FLAG_IDEA_MDP_639,
  LD_FLAG_IDEA_MDP_641,
  LD_FLAG_IDEA_MDP_645,
} from "@components/constants/launchDarklyFlagKeys";
import { TASKS_MODULE_LD_FLAG } from "@components/constants/tasksModule";

/**
 * Commit a flag value only when the caller explicitly provided it. Keeps the
 * repetitive `if (x !== undefined)` blocks in `setTestFlag` out of the action
 * body so the function stays under the cognitive-complexity limit.
 */
function commitFlagIfDefined(commit, value, mutation) {
  if (value !== undefined) {
    commit(mutation, value);
  }
}

const state = {
  isNewDesign: false,
  showEmployeeSidebar: true,
  ideaMDP378: false,
  ideaMDP381: false,
  ideaMDP389: false,
  ideaMDP412: false,
  ideaMDP427: false,
  ideaMDP449: false,
  ideaMDP176: false,
  ideaMDP432: false,
  ideaMDP442: false,
  ideaMDP441: false,
  dragDropAttachOrgObjectsPositionTreeMDP434: false,
  ideaMDP450: false,
  ideaMDP453: false,
  ideaMDP452: false,
  ideaMDP443: false,
  ideaMDP461Flag: false,
  ideaMDP546Flag: false,
  ideaMDP575: false,
  ideaMDP398: false,
  ideaMDP438: false,
  ideaMDP276: false,
  ideaMDP404: false,
  ideaMDP463: false,
  ideaMDP487: false,
  ideaMDP526: false,
  ideaMDP457: false,
  ideaMDP514: false,
  ideaMDP557: false,
  ideaMDP558: false,
  ideaMDP556: false,
  ideaMDP570: false,
  ideaMDP577: false,
  ideaMDP579: false,
  ideaMDP586: false,
  ideaMDP592: false,
  ideaMDP608: false,
  ideaMDP582: false,
  ideaMDP609: false,
  ideaMDP552: false,
  ideaMDP639: false,
  ideaMDP641: false,
  ideaMDP645: false,
};

const mutations = {
  SET_NEW_DESIGN(state, value) {
    state.isNewDesign = value;
  },
  SET_SHOW_SIDEBAR(state, value) {
    state.showEmployeeSidebar = value;
  },
  SET_IDEA_MDP_378(state, value) {
    state.ideaMDP378 = value;
  },
  SET_IDEA_MDP_381(state, value) {
    state.ideaMDP381 = value;
  },
  SET_IDEA_MDP_389(state, value) {
    state.ideaMDP389 = value;
  },
  SET_IDEA_MDP_412(state, value) {
    state.ideaMDP412 = value;
  },
  SET_IDEA_MDP_427(state, value) {
    state.ideaMDP427 = value;
  },
  SET_IDEA_MDP_449(state, value) {
    state.ideaMDP449 = value;
  },
  SET_IDEA_MDP_176(state, value) {
    state.ideaMDP176 = value;
  },
  SET_IDEA_MDP_432(state, value) {
    state.ideaMDP432 = value;
  },
  SET_IDEA_MDP_442(state, value) {
    state.ideaMDP442 = value;
  },
  SET_IDEA_MDP_441(state, value) {
    state.ideaMDP441 = value;
  },
  SET_DRAG_DROP_ATTACH_ORG_OBJECTS_POSITION_TREE_MDP434(state, value) {
    state.dragDropAttachOrgObjectsPositionTreeMDP434 = value;
  },
  SET_IDEA_MDP_450(state, value) {
    state.ideaMDP450 = value;
  },
  SET_IDEA_MDP_453(state, value) {
    state.ideaMDP453 = value;
  },
  SET_IDEA_MDP_452(state, value) {
    state.ideaMDP452 = value;
  },
  SET_IDEA_MDP_443(state, value) {
    state.ideaMDP443 = value;
  },
  SET_IDEA_MDP_461(state, value) {
    state.ideaMDP461Flag = value;
  },
  SET_IDEA_MDP_546(state, value) {
    state.ideaMDP546Flag = value;
  },
  SET_IDEA_MDP_575(state, value) {
    state.ideaMDP575 = value === true;
  },
  SET_IDEA_MDP_398(state, value) {
    state.ideaMDP398 = value;
  },
  SET_IDEA_MDP_438(state, value) {
    state.ideaMDP438 = value;
  },
  SET_IDEA_MDP_276(state, value) {
    state.ideaMDP276 = value;
  },
  SET_IDEA_MDP_404(state, value) {
    state.ideaMDP404 = value;
  },
  SET_IDEA_MDP_463(state, value) {
    state.ideaMDP463 = value;
  },
  SET_IDEA_MDP_487(state, value) {
    state.ideaMDP487 = value;
  },
  SET_IDEA_MDP_526(state, value) {
    state.ideaMDP526 = value === true;
    // Keep localStorageHelper in sync for synchronous getFilters/updateFilters.
    setPerAccessFilterPersistenceEnabled(state.ideaMDP526);
  },
  SET_IDEA_MDP_457(state, value) {
    state.ideaMDP457 = value === true;
  },
  SET_IDEA_MDP_514(state, value) {
    state.ideaMDP514 = value === true;
  },
  SET_IDEA_MDP_557(state, value) {
    state.ideaMDP557 = value === true;
  },
  SET_IDEA_MDP_558(state, value) {
    state.ideaMDP558 = value === true;
  },
  SET_IDEA_MDP_556(state, value) {
    state.ideaMDP556 = value === true;
  },
  SET_IDEA_MDP_570(state, value) {
    state.ideaMDP570 = value === true;
  },
  SET_IDEA_MDP_577(state, value) {
    state.ideaMDP577 = value === true;
  },
  SET_IDEA_MDP_579(state, value) {
    state.ideaMDP579 = value === true;
  },
  SET_IDEA_MDP_586(state, value) {
    state.ideaMDP586 = value === true;
  },
  SET_IDEA_MDP_592(state, value) {
    state.ideaMDP592 = value === true;
  },
  SET_IDEA_MDP_608(state, value) {
    state.ideaMDP608 = value === true;
  },
  SET_IDEA_MDP_582(state, value) {
    state.ideaMDP582 = value === true;
  },
  SET_IDEA_MDP_609(state, value) {
    state.ideaMDP609 = value === true;
  },
  SET_IDEA_MDP_552(state, value) {
    state.ideaMDP552 = value === true;
  },
  SET_IDEA_MDP_639(state, value) {
    state.ideaMDP639 = value === true;
  },
  SET_IDEA_MDP_641(state, value) {
    state.ideaMDP641 = value === true;
  },
  SET_IDEA_MDP_645(state, value) {
    state.ideaMDP645 = value === true;
  },
};

const actions = {
  async checkFeatureFlags({ commit }, currentRoute = null) {
    try {
      if (!launchDarklyService.isInitialized) {
        await launchDarklyService.initialize();
      }

      // Use the Vue plugin's reactive flags instead of direct client access
      const flags = await launchDarklyService.getAllFlags();
      const isNewDesign = flags["employee.page_horizontal_menu.enabled"] === true;
      const ideaMDP378 = flags["idea-MDP-378"] === true;
      commit("SET_NEW_DESIGN", isNewDesign);
      commit("SET_IDEA_MDP_378", ideaMDP378);
      const ideaMDP389 = flags["idea-MDP-389"] === true;
      commit("SET_NEW_DESIGN", isNewDesign);
      const ideaMDP381 = flags["idea-MDP-381"] === true;
      commit("SET_IDEA_MDP_381", ideaMDP381);
      commit("SET_IDEA_MDP_389", ideaMDP389);
      const ideaMDP412 = flags["idea-MDP-412"] === true;
      commit("SET_IDEA_MDP_412", ideaMDP412);
      const ideaMDP427 = flags["idea-MDP-427"] === true;
      commit("SET_IDEA_MDP_427", ideaMDP427);
      const ideaMDP449 = flags["idea-MDP-449"] === true;
      commit("SET_IDEA_MDP_449", ideaMDP449);
      const ideaMDP176 = flags["idea-MDP-176"] === true;
      commit("SET_IDEA_MDP_176", ideaMDP176);
      const ideaMDP432 = flags["idea-MDP-432"] === true;
      commit("SET_IDEA_MDP_432", ideaMDP432);
      const ideaMDP442 = flags["idea-MDP-442"] === true;
      commit("SET_IDEA_MDP_442", ideaMDP442);
      const ideaMDP441 = flags["idea-MDP-441"] === true;
      commit("SET_IDEA_MDP_441", ideaMDP441);
      const dragDropAttachOrgObjectsPositionTreeMDP434 = flags["idea-MDP-434"] === true;
      commit(
        "SET_DRAG_DROP_ATTACH_ORG_OBJECTS_POSITION_TREE_MDP434",
        dragDropAttachOrgObjectsPositionTreeMDP434
      );
      const ideaMDP450 = flags["idea-MDP-450"] === true;
      commit("SET_IDEA_MDP_450", ideaMDP450);
      const ideaMDP453 = flags["idea-MDP-453"] === true;
      commit("SET_IDEA_MDP_453", ideaMDP453);
      const ideaMDP452 = flags["idea-MDP-452"] === true;
      commit("SET_IDEA_MDP_452", ideaMDP452);
      // idea-MDP-443: read via `getFlag` (client.variation under the hood)
      // instead of the bulk `flags[...]` map to dodge the LD JS SDK race where
      // `allFlags()` can briefly return a stale snapshot right after
      // `identify(newContext)` — see ER-8672.
      const ideaMDP443 = (await launchDarklyService.getFlag("idea-MDP-443", false)) === true;
      commit("SET_IDEA_MDP_443", ideaMDP443);
      const ideaMDP461 = flags["idea-MDP-461"] === true;
      commit("SET_IDEA_MDP_461", ideaMDP461);
      const ideaMDP546 = flags["idea-MDP-546"] === true;
      commit("SET_IDEA_MDP_546", ideaMDP546);
      const ideaMDP575 = flags[TASKS_MODULE_LD_FLAG] === true;
      commit("SET_IDEA_MDP_575", ideaMDP575);
      const ideaMDP398 = flags["idea-MDP-398"] === true;
      commit("SET_IDEA_MDP_398", ideaMDP398);
      // idea-MDP-438: read via getFlag (same race rationale as idea-MDP-443 / ER-8672).
      const ideaMDP438 = (await launchDarklyService.getFlag("idea-MDP-438", false)) === true;
      commit("SET_IDEA_MDP_438", ideaMDP438);
      const ideaMDP276 = flags["idea-MDP-276"] === true;
      commit("SET_IDEA_MDP_276", ideaMDP276);
      const ideaMDP404 = flags["idea-MDP-404"] === true;
      commit("SET_IDEA_MDP_404", ideaMDP404);
      const ideaMDP463 = flags["idea-MDP-463"] === true;
      commit("SET_IDEA_MDP_463", ideaMDP463);
      const ideaMDP487 = flags["idea-MDP-487"] === true;
      commit("SET_IDEA_MDP_487", ideaMDP487);
      // idea-MDP-526: read via getFlag (same race rationale as idea-MDP-443 / ER-8672).
      const ideaMDP526 = (await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_526, false)) === true;
      commit("SET_IDEA_MDP_526", ideaMDP526);
      const ideaMDP457 = flags[LD_FLAG_IDEA_MDP_457] === true;
      commit("SET_IDEA_MDP_457", ideaMDP457);
      const ideaMDP514 = flags[LD_FLAG_IDEA_MDP_514] === true;
      commit("SET_IDEA_MDP_514", ideaMDP514);
      const ideaMDP557 = flags[LD_FLAG_IDEA_MDP_557] === true;
      commit("SET_IDEA_MDP_557", ideaMDP557);
      const ideaMDP558 = flags[LD_FLAG_IDEA_MDP_558] === true;
      commit("SET_IDEA_MDP_558", ideaMDP558);
      const ideaMDP556 = flags[LD_FLAG_IDEA_MDP_556] === true;
      commit("SET_IDEA_MDP_556", ideaMDP556);
      const ideaMDP570 = flags[LD_FLAG_IDEA_MDP_570] === true;
      commit("SET_IDEA_MDP_570", ideaMDP570);
      const ideaMDP577 = flags[LD_FLAG_IDEA_MDP_577] === true;
      commit("SET_IDEA_MDP_577", ideaMDP577);
      // idea-MDP-579: read via getFlag (same race rationale as idea-MDP-443 / ER-8672).
      const ideaMDP579 = (await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_579, false)) === true;
      commit("SET_IDEA_MDP_579", ideaMDP579);
      const ideaMDP586 = flags[LD_FLAG_IDEA_MDP_586] === true;
      commit("SET_IDEA_MDP_586", ideaMDP586);
      const ideaMDP592 = flags[LD_FLAG_IDEA_MDP_592] === true;
      commit("SET_IDEA_MDP_592", ideaMDP592);
      const ideaMDP608 = flags[LD_FLAG_IDEA_MDP_608_ORG_OBJECT_NAME_VALIDATION] === true;
      commit("SET_IDEA_MDP_608", ideaMDP608);
      const ideaMDP582 = flags[LD_FLAG_IDEA_MDP_582] === true;
      commit("SET_IDEA_MDP_582", ideaMDP582);
      const ideaMDP609 = flags[LD_FLAG_IDEA_MDP_609] === true;
      commit("SET_IDEA_MDP_609", ideaMDP609);
      const ideaMDP552 = flags[LD_FLAG_IDEA_MDP_552] === true;
      commit("SET_IDEA_MDP_552", ideaMDP552);
      const ideaMDP639 = flags[LD_FLAG_IDEA_MDP_639] === true;
      commit("SET_IDEA_MDP_639", ideaMDP639);
      const ideaMDP641 = flags[LD_FLAG_IDEA_MDP_641] === true;
      commit("SET_IDEA_MDP_641", ideaMDP641);
      const ideaMDP645 = flags[LD_FLAG_IDEA_MDP_645] === true;
      commit("SET_IDEA_MDP_645", ideaMDP645);
      // Update sidebar visibility based on route and flag
      if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
        commit("SET_SHOW_SIDEBAR", !isNewDesign);
      } else {
        commit("SET_SHOW_SIDEBAR", true);
      }
    } catch (error) {
      console.error("Error checking feature flags:", error);
      commit("SET_SHOW_SIDEBAR", true);
    }
  },

  updateSidebarVisibility({ state, commit }, currentRoute = null) {
    if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
      commit("SET_SHOW_SIDEBAR", !state.isNewDesign);
    } else {
      commit("SET_SHOW_SIDEBAR", true);
    }
  },

  // Method for testing - manually set the flag value
  setTestFlag(
    { commit },
    {
      isNewDesign,
      ideaMDP378,
      ideaMDP381,
      ideaMDP389,
      ideaMDP412,
      ideaMDP449,
      ideaMDP176,
      ideaMDP432,
      ideaMDP442,
      ideaMDP441,
      dragDropAttachOrgObjectsPositionTreeMDP434,
      ideaMDP450,
      ideaMDP453,
      ideaMDP452,
      ideaMDP443,
      ideaMDP461,
      ideaMDP546,
      ideaMDP575,
      ideaMDP398,
      ideaMDP438,
      ideaMDP276,
      ideaMDP404,
      ideaMDP463,
      ideaMDP487,
      ideaMDP526,
      ideaMDP457,
      ideaMDP514,
      ideaMDP557,
      ideaMDP558,
      ideaMDP556,
      ideaMDP570,
      ideaMDP577,
      ideaMDP579,
      ideaMDP586,
      ideaMDP592,
      ideaMDP608,
      ideaMDP582,
      ideaMDP609,
      ideaMDP552,
      ideaMDP639,
      ideaMDP641,
      ideaMDP645,
      currentRoute = null,
    }
  ) {
    commit("SET_NEW_DESIGN", isNewDesign);
    commit("SET_IDEA_MDP_378", ideaMDP378);
    commit("SET_IDEA_MDP_381", ideaMDP381);
    commit("SET_IDEA_MDP_389", ideaMDP389);
    commit("SET_IDEA_MDP_412", ideaMDP412);
    commit("SET_IDEA_MDP_449", ideaMDP449);
    commit("SET_IDEA_MDP_176", ideaMDP176);
    commit("SET_IDEA_MDP_432", ideaMDP432);
    commit("SET_IDEA_MDP_442", ideaMDP442);
    commit("SET_IDEA_MDP_441", ideaMDP441);
    commit("SET_IDEA_MDP_453", ideaMDP453);
    commit("SET_IDEA_MDP_452", ideaMDP452);
    commitFlagIfDefined(commit, ideaMDP443, "SET_IDEA_MDP_443");
    commit("SET_IDEA_MDP_461", ideaMDP461);
    commitFlagIfDefined(commit, ideaMDP546, "SET_IDEA_MDP_546");
    commitFlagIfDefined(commit, ideaMDP575, "SET_IDEA_MDP_575");
    commitFlagIfDefined(commit, ideaMDP398, "SET_IDEA_MDP_398");
    commitFlagIfDefined(commit, ideaMDP438, "SET_IDEA_MDP_438");
    commitFlagIfDefined(commit, ideaMDP276, "SET_IDEA_MDP_276");
    commitFlagIfDefined(commit, ideaMDP404, "SET_IDEA_MDP_404");
    commitFlagIfDefined(commit, ideaMDP463, "SET_IDEA_MDP_463");
    commitFlagIfDefined(commit, ideaMDP487, "SET_IDEA_MDP_487");
    commitFlagIfDefined(commit, ideaMDP526, "SET_IDEA_MDP_526");
    commitFlagIfDefined(commit, ideaMDP457, "SET_IDEA_MDP_457");
    commitFlagIfDefined(commit, ideaMDP514, "SET_IDEA_MDP_514");
    commitFlagIfDefined(commit, ideaMDP557, "SET_IDEA_MDP_557");
    commitFlagIfDefined(commit, ideaMDP558, "SET_IDEA_MDP_558");
    commitFlagIfDefined(commit, ideaMDP556, "SET_IDEA_MDP_556");
    commitFlagIfDefined(commit, ideaMDP570, "SET_IDEA_MDP_570");
    commitFlagIfDefined(commit, ideaMDP577, "SET_IDEA_MDP_577");
    commitFlagIfDefined(commit, ideaMDP579, "SET_IDEA_MDP_579");
    commitFlagIfDefined(commit, ideaMDP586, "SET_IDEA_MDP_586");
    commitFlagIfDefined(commit, ideaMDP592, "SET_IDEA_MDP_592");
    commitFlagIfDefined(commit, ideaMDP608, "SET_IDEA_MDP_608");
    commitFlagIfDefined(commit, ideaMDP582, "SET_IDEA_MDP_582");
    commitFlagIfDefined(commit, ideaMDP609, "SET_IDEA_MDP_609");
    commitFlagIfDefined(commit, ideaMDP552, "SET_IDEA_MDP_552");
    commitFlagIfDefined(commit, ideaMDP639, "SET_IDEA_MDP_639");
    commitFlagIfDefined(commit, ideaMDP641, "SET_IDEA_MDP_641");
    commitFlagIfDefined(commit, ideaMDP645, "SET_IDEA_MDP_645");
    commitFlagIfDefined(
      commit,
      dragDropAttachOrgObjectsPositionTreeMDP434,
      "SET_DRAG_DROP_ATTACH_ORG_OBJECTS_POSITION_TREE_MDP434"
    );
    commitFlagIfDefined(commit, ideaMDP450, "SET_IDEA_MDP_450");
    commitFlagIfDefined(commit, ideaMDP453, "SET_IDEA_MDP_453");
    if (currentRoute && currentRoute.meta.secondSidebar === "employee") {
      commit("SET_SHOW_SIDEBAR", !isNewDesign);
    } else {
      commit("SET_SHOW_SIDEBAR", true);
    }
  },
};

const getters = {
  showEmployeeSidebar: (state) => state.showEmployeeSidebar,
  isNewDesign: (state) => state.isNewDesign,
  ideaMDP378: (state) => state.ideaMDP378,
  ideaMDP381: (state) => state.ideaMDP381,
  ideaMDP389: (state) => state.ideaMDP389,
  ideaMDP412: (state) => state.ideaMDP412,
  ideaMDP427: (state) => state.ideaMDP427,
  ideaMDP449: (state) => state.ideaMDP449,
  ideaMDP176: (state) => state.ideaMDP176,
  ideaMDP432: (state) => state.ideaMDP432,
  ideaMDP442: (state) => state.ideaMDP442,
  ideaMDP441: (state) => state.ideaMDP441,
  dragDropAttachOrgObjectsPositionTreeMDP434: (state) =>
    state.dragDropAttachOrgObjectsPositionTreeMDP434,
  ideaMDP450: (state) => state.ideaMDP450,
  ideaMDP453: (state) => state.ideaMDP453,
  ideaMDP452: (state) => state.ideaMDP452,
  ideaMDP443: (state) => state.ideaMDP443,
  ideaMDP461: (state) => state.ideaMDP461Flag,
  ideaMDP546: (state) => state.ideaMDP546Flag,
  ideaMDP575: (state) => state.ideaMDP575,
  ideaMDP398: (state) => state.ideaMDP398,
  ideaMDP438: (state) => state.ideaMDP438,
  ideaMDP276: (state) => state.ideaMDP276,
  ideaMDP404: (state) => state.ideaMDP404,
  ideaMDP463: (state) => state.ideaMDP463,
  ideaMDP487: (state) => state.ideaMDP487,
  ideaMDP526: (state) => state.ideaMDP526,
  ideaMDP457: (state) => state.ideaMDP457,
  ideaMDP514: (state) => state.ideaMDP514,
  ideaMDP557: (state) => state.ideaMDP557,
  ideaMDP558: (state) => state.ideaMDP558,
  ideaMDP556: (state) => state.ideaMDP556,
  ideaMDP570: (state) => state.ideaMDP570,
  ideaMDP577: (state) => state.ideaMDP577,
  ideaMDP579: (state) => state.ideaMDP579,
  ideaMDP586: (state) => state.ideaMDP586,
  ideaMDP592: (state) => state.ideaMDP592,
  ideaMDP608: (state) => state.ideaMDP608,
  ideaMDP582: (state) => state.ideaMDP582,
  ideaMDP609: (state) => state.ideaMDP609,
  ideaMDP552: (state) => state.ideaMDP552,
  ideaMDP639: (state) => state.ideaMDP639,
  ideaMDP641: (state) => state.ideaMDP641,
  ideaMDP645: (state) => state.ideaMDP645,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
